import { render, staticRenderFns } from "./MisDocuments.vue?vue&type=template&id=0fca1980&scoped=true&"
import script from "./MisDocuments.vue?vue&type=script&lang=js&"
export * from "./MisDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MisDocuments.vue?vue&type=style&index=0&id=0fca1980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca1980",
  null
  
)

export default component.exports